import React from 'react';
import { CheckCircle2, CircleDashed, XCircle, MinusCircle } from 'lucide-react';

export const PAY_STATUS = {
  paid: { label: 'Paid', cls: 'bg-emerald-100 text-emerald-800 border-emerald-300', icon: CheckCircle2 },
  part_paid: { label: 'Part paid', cls: 'bg-amber-100 text-amber-800 border-amber-300', icon: CircleDashed },
  not_paid: { label: 'Not yet paid', cls: 'bg-red-100 text-red-800 border-red-300', icon: XCircle },
  no_fee: { label: 'No fee set', cls: 'bg-slate-100 text-slate-600 border-slate-300', icon: MinusCircle },
};

export const StatusPill = ({ status, testid }) => {
  const s = PAY_STATUS[status] || PAY_STATUS.no_fee;
  const Icon = s.icon;
  return (
    <span className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-semibold ${s.cls}`} data-testid={testid}>
      <Icon className="w-3.5 h-3.5" /> {s.label}
    </span>
  );
};

export const shiftMonth = (m, n) => {
  const [y, mo] = m.split('-').map(Number);
  const d = new Date(Date.UTC(y, mo - 1 + n, 1));
  return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}`;
};

export const monthName = (m) => {
  const [y, mo] = m.split('-').map(Number);
  return new Date(Date.UTC(y, mo - 1, 1)).toLocaleDateString('en-ZA', { month: 'long', year: 'numeric', timeZone: 'UTC' });
};

export const monthOptions = (center, back = 12, ahead = 12) => {
  const out = [];
  for (let i = -back; i <= ahead; i += 1) out.push(shiftMonth(center, i));
  return out;
};

export const METHOD_LABEL = { eft: 'EFT', cash: 'Cash' };
